import { gql } from '$lib/apollo';

// this query does a 3rd party call, so be careful with it
export const GET_BILLING_INFO = gql`
  query GetBillingInfo {
    currentSession {
      id
      pastDueStatus {
        pastDue
        amount {
          value
        }
      }
      billingInfo {
        id
        type
        country
        postalCode
        firstName
        lastName
        paymentMethod {
          type
          cardType
          expMonth
          expYear
          firstSix
          lastTwo
          lastFour
        }
      }
    }
  }
`;

export const UPDATE_METAFY_PRO_CREDIT = gql`
  mutation UpdateMetafyPartnerCredit($input: AccountEditInput!) {
    accountEdit(input: $input) {
      result {
        id
        metafyPartner
        useCreditForMetafyPro
      }
      errors {
        ... on Error {
          code
          message
        }
      }
    }
  }
`;
